import React from "react";

export const RULES_DATA = [
  {
    heading: "Football Fancy",
    rules: [
      {
        danger: true,
        text: "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of vpn/robot-use/multiple entry from same IP/ multiple bets at same time (Punching) and others. Note : only winning bets will be voided...",
      },
      {
        danger: true,
        text: "Tournament Total Goals, Team Total Goals goals.scored in 90 minutes or in extra-time will count.Goals scored in penalty shootouts do not count.",
      },
      {
        danger: true,
        text: "Tournament Corners - Only corners taken in 90 minutes count.",
      },
      {
        danger: true,
        text: "Tournament Penalties Missed/Converted - Penalties taken in 90 minutes, extra-time and penalty shootouts all count. If a penalty has to be re-taken the previous disallowed penalty(ies) do not count.",
      },
    ],
  },
  {
    heading: "BBL SPECIAL",
    rules: [
      {
        danger: true,
        text: "If BBL fixture of 44 matches gets reduced due to any reason, then all the special fancies will be voided (Match abandoned due to rain/bad light will not be considered in this)",
      },
      {
        danger: true,
        text: "At any situation if result is given for any particular event based on the rates given for the same, then the particular result will be considered valid, similarly if the tournament gets canceled due to any reason the previously given result will be considered valid",
      },
      { text: "1. Highest Innings run - Only First Innings is Valid" },
      { text: "2. Lowest Innings run - Only First Innings is Valid" },
      {
        text: "3. Highest Total Runs in Single Match of BBL: Maximum Runs Scored by 2 Teams in Single Match.",
      },
      {
        text: "4. Largest Margin Win by Runs of BBL : Maximum Runs Margin Win by Any Team. Example : PS 210 in 1st Inn and SS 150 in 2nd Inn Means PS Win by 60 run Margin.",
      },
      { text: "5. Highest Partnership Runs in BBL: Both Innings are Valid" },
      { text: "6. Highest Partnership Balls in BBL: Both Innings are Valid" },
      {
        text: "7. Highest Partnership Boundaries in BBL: Both Innings are Valid",
      },
      {
        text: "8. In fastest fifty always the first 50 runs will be considered, for example of S Smith scores 1st fifty in 17 balls and scores 100 in next 14 balls, fastest 50 will be given based on the balls for the 1st fifty runs",
      },
      {
        text: "9. Highest Run Scorer Runs : Total Runs Scored by An Individual Batsman in Full Tournament (BBL GOLDEN BAT)",
      },
      {
        text: "10. Highest Wicket Taker Wickets: Total Wickets Taken by a Bowler in Full Tournament (BBL GOLDEN ARM)",
      },
      {
        text: "11. How Many time 5 or More Wickets taken by Bowlers : Number of time 5 or More Wickets taken by Bowlers. In Case Same Bowler 2 time 5 or More Wickets taken means Result Counted as 2.",
      },
      {
        text: "12. Total 1st Over Runs : Average 6 Runs will be given in case match abandoned or over reduced. 1st Inn Match 1st Over Runs Only Considered",
      },
      {
        text: "13. Total 4's: Average 26 Fours will be given in case match abandoned or over reduced",
      },
      {
        text: "14. Total 6's: Average 12 Sixes will be given in case match abandoned or over reduced",
      },
      {
        text: "15. Total Boundaries: Average 38 Boundaries will be given in case match abandoned or over reduced",
      },
      {
        text: "16. Total Wickets - Average will 13 Wickets be given in case match abandoned or over reduced",
      },
      {
        text: "17. Total Wides - Average 8 Wides will be given in case match abandoned or over reduced",
      },
      {
        text: "18. Total Extras - Average 16 Extras will be given in case match abandoned or over reduced",
      },
      {
        text: "19. Total Caught outs: Average 9 Caught out will be given in case match abandoned or over reduced",
      },
      {
        text: "20. Total Bowled:- Average 2 Bowled out will be given in case match abandoned or over reduced",
      },
      {
        text: "21. Total LBW:- Average 1 LBW will be given in case match abandoned or over reduced",
      },
      {
        text: "22. Total Run out:- Average 1 Run out will be given in case match abandoned or over reduced",
      },
      {
        text: "23. Total 30's: Average 3 Thirties will be given in case match abandoned or over reduced",
      },
      {
        text: "24. Total 50's: Average 1 Fifties will be given in case match abandoned or over reduced",
      },
      {
        text: "25. Total Duckouts in BBL : Average 1 Duckout will be given in case match abandoned or over reduced",
      },
      {
        text: "26. Total Single Digit Scorers in BBL : Average 6 Single Digit Scorers will be given in case match abandoned or over reduced.Duck outs Not Considered in this Event. If Not out Batsman/Injured Batsman facing One Legal Delivery and nothing scored ('0') means Considered as Single Digit",
      },
      {
        text: "27. Total Double Digit Scorers in BBL : Average 9 Double Digit Scorers will be given in case match abandoned or over reduced",
      },
      {
        text: "28. Total Players Facing 25 plus Balls in BBL : Average 3 Players will be given in case match abandoned or over reduced",
      },
      {
        text: "29. Total Impact Overs in BBL : Average 14 Impact Over will be given in case match abandoned or over reduced.Number of over's scored 10 runs and above. If a team all out or Match Resulted in 15.2 then considered as 16 over.",
      },
      {
        text: "30. Total No Boundaries Overs in BBL : Average 14 No Boundaries Over will be given in case match abandoned or over reduced.If Match Resulted in 2nd Inn 17 Overs Means How Many Overs Boundaries not Came in that 37 Overs Only Considered.Balance 3 Overs not Considered in this.",
      },
      {
        text: "31. Total Four Hitters in BBL : Average 9 Four Hitter will be given in case match abandoned or over reduced",
      },
      {
        text: "32. Total Six Hitters in BBL : Average 6 Six Hitter will be given in case match abandoned or over reduced",
      },
      {
        text: "33. Total Wicket Takers in BBL : Average 7 Wicket Taker will be given in case match abandoned or over reduced",
      },
      {
        text: "34. Total Bowler Giving 30plus Runs in BBL : Average 5 Bowlers will be given in case match abandoned or over reduced",
      },
      {
        text: "35. Total Highest Scoring Over Runs in BBL: Total of Every Match Highest Scoring Over Runs. Average 20 Runs will be given in case match abandoned or over reduced.",
      },
      {
        text: "36. Highest Match 1st Over Run of BBL : Only First Innings is Valid.",
      },
      {
        text: "37. Highest 1st 6 over run: Only First Innings is Valid.Will not consider if over reduce before completion 6 over.",
      },
      {
        text: "38. Highest 1st 10 over run : Only First Innings is Valid.Will not consider if over reduce before completion 10 over.",
      },
      {
        text: "39. Highest 4s,6s,Boundaries,Wickets,Wides,Extras,Caught Outs,Bowled,Lbw, Runouts,30s,50s, Duckouts,Single Digit Scorers, Double Digit Scorers,Players 25+ balls, Impact Overs, Noboundary Overs,Four Hitter,Six Hitter,Wicket Takers and Bowler 30+ Runs in individual match: All Both Innings are Counted.",
      },
      { text: "40. Highest Scoring Over Runs in BBL: Both Innings are Valid" },
      {
        text: "41. Most Balls Faced By a Batsman of BBL : Maximum balls Faced by an Individual Batsman in the Single Match.",
      },
      {
        text: "42. Most 4's by a Batsman in an Inn of BBL : Maximum 4s Hitted by an Individual Batsman in any Single Match",
      },
      {
        text: "43. Most 6's by a Batsman in an Inn of BBL : Maximum 6s Hitted by an Individual Batsman in any Single Match",
      },
      {
        text: "44. Most Boundaries Given by a Bowler in an Inn of BBL : Maximum Boundaries Conceded By Single Bowler in His 4 Overs.",
      },
      {
        text: "45. Most Dotballs By a Bowler in an Inn of BBL : Maximum Dotballs By Single Bowler in His 4 Overs.",
      },
      {
        text: "46. Most Runs Given by Bowler in an Inning of BBL : Maximum Runs conceded by a individual Bowler in an Innings.",
      },
      {
        text: "47. Most 4s hitted by a Batsman of BBL : Maximum Fours Hitted by Single Batsman in Full Tournament.",
      },
      {
        text: "48. Most 6s hitted by a Batsman of BBL : Maximum Sixes Hitted by Single Batsman in Full Tournament.",
      },
      {
        text: "49. Most 50s Scored by a Batsman of BBL : Maximum 50s Scored by Single Batsman in Full Tournament.",
      },
      {
        text: "50. Most 4s,6s,Wide,Extras,Caught Outs,Bowled,LBW,Single Digit Scorers, Double Digit Scorers, Four Hitters,Six Hitters and Wicket Takers in an Innings Of the Match : Considered For Maximum Reached Any Innings.All Both Innings Considered as Valid",
      },
      { text: "51. Super over will not be included" },
      {
        danger: true,
        text: "If the match starts Over Reduced Game or 20 Over Game, after the balls are reduced due to rain interrupting means comparison Events like Highest 4s,6s, boundaries,30s,50s, Wickets,Wides,Extras,Caughtouts,Bowled,Lbw,Runout,Duckout,Single Digit Scorers, Double Digit Scorers and Most 4s,6s,boundaries,30s,50s, Caught outs,Bowled,Duckout, wicket Keeper Dismissals all are considered for Result.",
      },
      {
        danger: true,
        text: "Example : If a match started as 20 Overs game after rain Overs reduced to 16 Overs match, in that match Maximum 6s reached means that Value considered for Result",
      },
    ],
  },
  {
    heading: "Women's Big Bash League",
    rules: [
      {
        danger: true,
        text: "If WBBL fixture of 43 matches gets reduced due to any reason, then all the special fancies will be voided (Match abandoned due to rain/bad light will not be considered in this) At any situation if result is given for any particular event based on the rates given for the same, then the particular result will be considered valid, similarly if the tournament gets canceled due to any reason the previously given result will be considered valid. Management decision will be final",
      },
      { text: "1. Highest innings run - Only First innings is valid" },
      { text: "2. Highest Partnership Run: Both Innings are valid" },
      {
        text: "3. Highest Run Scorer Runs: Total Runs Scored by An Individual Batsman in Full Tournament. (WBBL Golden Bat).",
      },
      {
        text: "4. Total 4's: Average 30 Fours will be given in case match abandoned or over reduced",
      },
      {
        text: "5. Total 6's: Average 5 Sixes will be given in case match abandoned or over reduced",
      },
      {
        text: "6. Total Boundaries: Average 35 Boundaries will be given in case match abandoned or over reduced",
      },
      {
        text: "7. Total 30's: Average 2 Thirties will be given in case match abandoned or over reduced",
      },
      {
        text: "8. Total 50's: Average 1 Fifties will be given in case match abandoned or over reduced",
      },
      {
        text: "9. Total Wickets - Average will 13 Wickets be given in case match abandoned or over reduced",
      },
      {
        text: "10. Total Wides - Average 9 Wides will be given in case match abandoned or over reduced",
      },
      {
        text: "11. Total No balls:- Average 1 No ball will be given in case match abandoned or over reduced",
      },
      {
        text: "12. Total Extras - Average 16 Extras will be given in case match abandoned or over reduced",
      },
      {
        text: "13. Total Caught outs: Average 8 Caught out will be given in case match abandoned or over reduced",
      },
      {
        text: "14. Total Bowled:- Average 2 Bowled out will be given in case match abandoned or over reduced",
      },
      {
        text: "15. Total LBW:- Average 1 LBW will be given in case match abandoned or over reduced",
      },
      {
        text: "16. Total Run out:- Average 1 Run out will be given in case match abandoned or over reduced",
      },
      {
        text: "17. Total Duckouts : Average 1 Duckout will be given in case match abandoned or over reduced",
      },
      {
        text: "18. Total Single Digit Scorers : Average 7 Single Digit Scorers will be given in case match abandoned or over reduced. Duck outs Not Considered in this Event. If Not out Batsman/Injured Batsman facing One Legal Delivery and nothing scored ('0') means Considered as Single Digit",
      },
      {
        text: "19. Total Double Digit Scorers: Average 8 Double Digit Scorers will be given in case match abandoned or over reduced",
      },
      {
        text: "20. Total of Impact Overs : Average 10 Impact Overs will be given in case match abandoned or over reduced. Number of over's scored 10 runs and above. If a team all out or Match Resulted in 15.1 then considered as 16 over.",
      },
      {
        text: "21. Total 50+ Partnerships - Average 2 Fifty plus Partnerships will be given in case match abandoned or over reduced. 50 and 50 Above Partnerships All Counted in this.",
      },
      {
        text: "22. Highest 1st 6 over run: Both Innings are Valid.Will not consider if over reduce before completion 6 over.",
      },
      {
        text: "23. Highest 1st 10 over run : Both Innings are Valid.Will not consider if over reduce before completion 10 over.",
      },
      {
        text: "24. Highest 4s,6s,30s,50s,Wickets,Wides,Extras,Caught Outs,Bowled,Lbw, Runouts, Duckouts,Single Digit Scorers,Double Digit Scorers, 50+ Pships and Impact Overs in individual match: All Both innings are Counted.",
      },
      {
        text: "25. Highest Scoring Over Runs : Maximum Runs Scored in any Single Over in Full Tournament.",
      },
      {
        text: "26. Most 4s,6s,Boundaries,30s,50s,Wides, Extras,Caught Outs,Bowled,Duckouts and Impact Overs in an Innings Of the Match : Considered For Any Innings.All Both Innings Considered as Valid",
      },
      {
        text: "27. Most 4's by individual batsman in a Match : Maximum 4s Hitted by an Individual Batsman in any Single Match",
      },
      {
        text: "28. Most 6's by individual batsman in a Match : Maximum 6s Hitted by an Individual Batsman in any Single Match",
      },
      {
        text: "29. Most Balls Faced By a Batsman : Maximum balls Faced by an Individual Batsman in the Single Match.",
      },
      {
        text: "30. Most runs given by Bowler in an Inning : Maximum Runs conceded by a individual Bowler in an Innings.",
      },
      {
        text: "31. Most wickets by Bowler in an inning : Maximum Wickets taken by a individual Bowler in an Innings",
      },
      {
        text: "32. If the match starts as a 20 Over game, after the balls are reduced due to rain interrupting means comparison Events like Highest 4s,6s, boundaries,30s,50s, Wickets,Wides,Extras,Caughtouts,Bowled,Lbw,Runout,Duckout,Single Digit Scorers, Double Digit Scorers and Most 4s,6s,boundaries,30s,50s, Caught outs,Bowled,Duckout, wicket Keeper Dismissals all are considered for Result.",
      },
      {
        text: "33. Due to Rain match started as Overs reduced match all the comparison Events not considered for Result. Example: Due to Rain match only 8 Overs both side Means Maximum Single Digit Scorers reached maximum in that match means Not considered for Result.",
      },
      { text: "34. Super over will not be included." },
      {
        text: "35. Lowest innings run (1st Inn) - Only First innings is valid. 1st Inning playing team must be Played 20 Overs or If team get all out means Only considered.",
      },
      { text: "36. Lowest innings run (Both Inn) - Both innings are valid." },
    ],
  },
  {
    heading: "Lunch Favourite",
    rules: [
      {
        danger: true,
        text: "1. The team which is favourite at lunch will be considered as lunch favourite or the team which is favourite after first inning last ball will be considered as lunch favourite in our exchange.",
      },
      {
        danger: true,
        text: "2. In any circumstances management decision will be final.",
      },
      {
        danger: true,
        text: "3. In case of tie in T20 or one day in lunch favourite game , all bets will be deleted in our exchange.",
      },
      {
        danger: true,
        text: "4. In case overs are reduced in a match, the team which favourite at lunch will be considered as lunch favourite.",
      },
      {
        text: "4.1 For example :- if match is reduced to 18 over per side in t20 or Oneday then after 18 over the team which is favourite at lunch will be considered as lunch favourite.",
      },
      {
        danger: true,
        text: "5. In case of weather, 1st innings match overs are reduced and direct target is given to team which will bat in 2nd inning then lunch favourite will be considered after target is given at lunch.",
      },
      {
        text: "5.1 For example :- in T20 match rain comes at 14 over and match is interrupted due to rain and direct target is given to 2nd batting team, then team which is favourite in match odds after target is given in match, will be considered as lunch favourite.",
      },
    ],
  },
  {
    heading: "Bookmaker",
    rules: [
      {
        danger: true,
        text: "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. For example incase of vpn/robot-use/multiple entry from same IP/ multiple bets at same time (Punching) and others. Note : only winning bets will be voided...",
      },
      {
        danger: true,
        text: "Due to any reason any team will be getting advantage or disadvantage we are not concerned.",
      },
      {
        danger: true,
        text: "Any query about the result or rates should be contacted within 7 days of the specific event, the same will not be considered valid post 7 days from the event.",
      },
      {
        danger: true,
        text: "If two team ends up with equal points, then result will be given based on the official point table",
      },
      {
        danger: true,
        text: "We will simply compare both teams 10 overs score higher score team will be declared winner in ODI (If both teams same score means, low wickets team will be declared winner. In case, both teams same score & same wickets means highest boundaries team will be declared winner. If all same then will be declared No result)",
      },
      {
        danger: true,
        text: "We will simply compare both teams 6 overs higher score team will be declared winner in T20 matches (If both teams same score means, low wickets team will be declared winner. In case, both teams same score & same wickets means highest boundaries team will be declared winner. If all same then will be declared No result)",
      },
      { danger: true, text: "Tennis:- Advance fancy market" },
      {
        text: "If the second set is not completed all bets regarding this market will be voided",
      },
      {
        text: "If a player retires after completion of second set, then the market will be settled as three sets",
      },
      { danger: true, text: "Virtual Cricket" },
      {
        text: "At any situation if the video gets interrupted/stopped then the same cannot be continued due to any technical issues bookmaker market will be voided",
      },
    ],
  },
  {
    heading: "Politics",
    rules: [
      { danger: true, text: "Indian state legislative assembly elections." },
      {
        text: "1. This event is to decide the winner of various legislative assemblies of india.",
      },
      {
        text: "2. The final result declared by election commission of india for assembly elections of various states of india for a particular year will be valid in our exchange, The customers are entirely responsible for their bets at all times.",
      },
      {
        text: "3. All bets will be voided if the election doesn't take place in given time by election commission or as per our exchange management decision.",
      },
      {
        text: "4. Company reserves the right to suspend/void any bets on this event at any time if we find the same not to be legitimate with the certainty of the outcome.",
      },
      {
        text: "5. Accidental issues during assembly elections will not be counted in our exchange, If required Additional candidates may be added on request.",
      },
      {
        text: "6. Kindly be informed no candidates will be partially settled and will remain in the market until it is fully settled.",
      },
      {
        text: "7. Please be informed that the transmissions described as 'live' by few broadcasters may actually be delayed due to multiple scenarios.",
      },
      {
        text: "8. If any candidate withdraws for any reason, including death, all bets on the market will be valid and be settled as per the defined rules.",
      },
    ],
  },
  {
    heading: "Genie Combo Special",
    rules: [
      { danger: true, text: "What is Genie Bet?" },
      {
        text: "Mumbai Indians will win + Quinton De Kock will score 20+ runs + Total Match Runs 385+ = 41.00 Combined Rate.",
      },
      {
        text: "1. If a ball is not bowled during a match, then all bets will be void.",
      },
      {
        text: "2. In the event of a match being decided by a bowl-off or toss of the coin, all bets will be void.",
      },
      {
        text: "3. If a player included in any selection in the bet is not named in the official starting XI then the whole bet will be made void, regardless of the rest of the selections within the bet.",
      },
      {
        text: "4. In the case of official substitutes/impact players etc, bets containing players that are official substitutes and not in the official starting XI's will be void.",
      },
      {
        text: "5. Any void selection within your bet, will deem the entire bet void.",
      },
      {
        text: "6. In the event of a batsman retiring for any reason, all relevant batting markets for this batsman will be settled on the runs at the time of their retirement.",
      },
      {
        text: "7. Penalty runs will not be included in any settlement totals.",
      },
      {
        text: "8. In case of rain or If over gets reduced then all bets will be void.",
      },
    ],
  },
  {
    heading: "Fancy Market",
    rules: [
      { danger: true, text: "Even odd game betting rate rules." },
      {
        text: "1. Completed game is valid, in case due to rain over are reduced or match abandoned particular game will be deleted.",
      },
      {
        text: "2. All bets regarding to ODD/EVEN player/partnership are valid if one legal delivery is being played, else the bets will be deleted.",
      },
      {
        text: "3. If particular session result is valid then particular Odd/Even session is also valid.",
      },
      { text: "4. In any circumstances management decision will be final." },
      { danger: true, text: "Last Digit Lottery:-" },
      { text: "1. Lottery means Last Digit." },
      {
        text: "2. Completed Lottery Will be Settled, Incomplete Lottery Will be voided.",
      },
      {
        text: "3. Example :- We will Count Last Digit of particular Lottery Market, if in 6 over Market the Score is 42, so we will settle that particular market 2 Number.",
      },
      {
        text: "4. In case of Rain or If Over Gets Reduced then this Market will get Voided.",
      },
      {
        text: "5. If Particular Session Result is valid then Particular Lottery Market also is valid.",
      },
      { danger: true, text: "Special Fancy:-" },
      {
        text: "1. 6 Sixes in an Over Adv, 6 Fours in an Over Adv Special fancy will be settled if match complete whether it is with the DLS method.",
      },
      {
        text: "2. Only 13.4 Ball Wicket in 1st Inning Adv - if mentioned particular ball is not completed then all bets will be void even if match is completed.",
      },
      { danger: true, text: "Retired hurt / out:-" },
      {
        text: "1. In partnership one batsman is injured retire hurt means partnership will continued in next batsman.",
      },
      {
        text: "2. If player retire out then nextman out will be considered as valid, and method fancy bets will be voided.",
      },
      { danger: true, text: "Top batsman rules:-" },
      {
        text: "1. If any player does not come as per playing eleven then all bets will be get deleted for the particular player.",
      },
      {
        text: "2. Two players done the same run in a single match (M Agarwal 30 runs and A Rayudu 30 runs, whole inning top batsmen score also 30 run) then both player settlement to be get done 50 percent rate on their original value.",
      },
      { danger: true, text: "Man of the Match Rules" },
      {
        text: "1. All bets will be deleted in case the match is abandoned or over reduced.",
      },
      {
        text: "2. All bets will be deleted if the mentioned player is not included in playing 11.",
      },
      {
        text: "3. In case Man of the Match is shared between two players then Dead heat rule will be applicable, settlement will be done 50% of the rates accordingly.",
      },
      { text: "4. Rules similar to our Top Batsman rules." },
      { danger: true, text: "Maximum Sixes by Team" },
      {
        text: "1. All bets will be deleted if match abandoned or over reduced.",
      },
      {
        text: "2. All bets will be deleted if both the teams hits same number of sixes.",
      },
      { text: "3. Super over will not be considered." },
      { danger: true, text: "Maximum 6 or 10 over runs" },
      {
        text: "1. All bets will be deleted if match abandoned or over reduced.",
      },
      {
        text: "2. All the bets will be deleted if both the teams score is same (Runs scored in 6 or 10 overs).",
      },
      { text: "3. 6 overs for T20 and 10 overs for ODI." },
      { text: "4. Both the innings are valid." },
      {
        text: "5. This fancy will be valid for 1st 6 overs of both innings for T20 and 1st 10 overs of both innings for ODI.",
      },
      { danger: true, text: "Penalty Runs Rule" },
      {
        text: "Penalty runs will be counted in all fancy. (This rule applicable from 20th March 2024)",
      },
    ],
  },
  {
    heading: "Ashes Special",
    rules: [
      {
        danger: true,
        text: "If Ashes fixture of 5 Matches gets Reduced Due to Any Reason, Then all the Special Fancies will be Voided. Management decision will be final.",
      },
      {
        text: "1. Total 1st Over Runs of Ashes: Total of All Five Match 1st Over Runs. Match 1st Innings Only Valid. In Case Match Abandoned Means 3 Runs Average will be Given.",
      },
      {
        text: "2. Total 1st 5 Over Runs of Ashes: Total of All Five Match 1st 5 Over Runs. Match 1st Innings Only Valid. In Case Match Abandoned Means 17 Runs Average will be Given.",
      },
      {
        text: "3. Total 1st 10 Over Runs of Ashes: Total of All Five Match 1st 10 Over Runs. Match 1st Innings Only Valid. In Case Match Abandoned Means 35 Runs Average will be Given.",
      },
      {
        text: "4. Highest Single Innings Score of Ashes: Maximum Runs Scored by any Team in their any Single Innings.",
      },
      {
        text: "5. Highest Total Runs of Ashes: Maximum Runs Scored in any Single Match of Series. All Innings Counted.",
      },
      {
        text: "6. High Partnership Runs of Ashes: Highest Partnership Runs Scored by Players in any Innings.",
      },
      {
        text: "7. High Partnership Balls of Ashes: Highest Partnership Balls Faced by Players in any Innings.",
      },
      {
        text: "8. Top Batsman Runs in an Inn of Ashes: Maximum Runs Scored by a Batsman in Single Innings.",
      },
      {
        text: "9. Highest Run Scorer Runs of Ashes: Maximum Runs Scored by Any Individual Batsman in Full Tournament.",
      },
      {
        text: "10. Highest Wicket Taker Wickets of Ashes: Maximum Wickets Taken by Any Individual Bowler in Full Tournament.",
      },
      {
        text: "11. Events Based in Total Counts of Full Match All Valid Only Match will be 300 Overs has been Played with Draw or Match has been won by Any team.",
      },
      {
        text: "12. Total 4s of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 115 Fours will be Counted as Average.",
      },
      {
        text: "13. Total Wkts of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 34 Wickets will be Counted as Average.",
      },
      {
        text: "14. Total Wides of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 9 Wides will be Counted as Average.",
      },
      {
        text: "15. Total Noballs of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 14 Noballs will be Counted as Average.",
      },
      {
        text: "16. Total Extras of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 55 Extras will be Counted as Average.",
      },
      {
        text: "17. Total Caught Outs of Ashes: In Case Match Abandoned or Draw with Below 300 Over Means 22 Caught outs will be Counted as Average.",
      },
      {
        text: "57. Highest Scoring Over Runs in Ashes: Maximum Runs Scored in Single Over of any Match.",
      },
      {
        text: "58. Most Balls faced by a Batsman in an Inn of Ashes: Maximum Balls Faced by a Batsman in Single Innings of any Match.",
      },
      {
        text: "63. Most Wickets Taken by a Bowler in an Inn of Ashes: Maximum Wickets Taken by Any Bowler in Single Innings.",
      },
      {
        text: "64. Most Wickets Taken by a Bowler in a Match of Ashes: Maximum Wickets Taken by Any Bowler in Full Match. Both Innings Wickets Counted.",
      },
    ],
  },
  {
    heading: "IPL",
    rules: [
      { danger: true, text: "Indian Premier League (IPL)" },
      {
        text: "If IPL fixture of 74 matches gets reduced due to any reason, then all the special fancies will be voided (Match abandoned due to rain/bad light will not be considered in this).",
      },
      {
        text: "At any situation if result is given for any particular event based on the rates given for the same, then the particular result will be considered valid.",
      },
      { text: "Management decision will be final." },
      { text: "Highest innings run - Only First innings is valid." },
      { text: "Lowest innings run - Only First innings is valid." },
      { text: "Highest Partnership Runs in IPL: Both Innings are valid." },
      {
        text: "Highest Run Scorer: Total Runs Scored by An Individual Batsman in Full Tournament.",
      },
      {
        text: "Highest Wicket Taker: Total Wickets Taken by a Bowler in Full Tournament.",
      },
      {
        text: "Total 4's: Average 29 Fours will be given in case match abandoned or over reduced.",
      },
      {
        text: "Total 6's: Average 16 Sixes will be given in case match abandoned or over reduced.",
      },
      {
        text: "Total 30's: Average 2 Thirties will be given in case match abandoned or over reduced.",
      },
      {
        text: "Total 50's: Average 2 Fifties will be given in case match abandoned or over reduced.",
      },
      {
        text: "Total No balls:- Average 1 No ball will be given in case match abandoned or over reduced.",
      },
      {
        text: "Total Wickets - Average will 12 Wickets be given in case match abandoned or over reduced.",
      },
      {
        text: "Total Wides - Average 11 Wides will be given in case match abandoned or over reduced.",
      },
      {
        text: "Total Extras - Average 18 Extras will be given in case match abandoned or over reduced.",
      },
      {
        text: "Total Caught outs: Average 9 Caught out will be given in case match abandoned or over reduced.",
      },
      {
        text: "Total Bowled:- Average 2 Bowled out will be given in case match abandoned or over reduced.",
      },
      {
        text: "Total LBW:- Average 1 LBW will be given in case match abandoned or over reduced.",
      },
      {
        text: "Total Run out:- Average 1 Run out will be given in case match abandoned or over reduced.",
      },
      {
        text: "Total Duckouts in IPL : Average 1 Duckout will be given in case match abandoned or over reduced.",
      },
      {
        text: "Total 50+ Partnerships - Average 2 Fifty plus Partnerships will be given in case match abandoned or over reduced.",
      },
      {
        text: "Highest 1st 6 over run: Only First Innings is Valid. Will not consider if over reduce before completion 6 over.",
      },
      {
        text: "Highest 1st 10 over run: Only First Innings is Valid. Will not consider if over reduce before completion 10 over.",
      },
      { danger: true, text: "Super over will not be included." },
    ],
  },
  {
    heading: "The Hundred Men's",
    rules: [
      {
        text: "1. If Hundred fixture of 34 matches gets reduced due to any reason, then all the special fancies will be voided.",
      },
      {
        text: "2. At any situation if result is given for any particular event based on the rates given for the same, then the particular result will be considered valid.",
      },
      { text: "3. Management decision will be final." },
      { text: "4. Highest innings run - Only First innings is valid." },
      {
        text: "5. Lowest innings run - Only First innings is valid. 1st Inning playing team must be facing 100 balls or If team get all out means considered.",
      },
      {
        text: "6. Highest Partnership Runs in Hundred: Both Innings are valid.",
      },
      {
        text: "7. Highest Partnership Balls in Hundred: Both Innings are valid.",
      },
      {
        text: "8. Highest Run Scorer: Total Runs Scored by An Individual Batsman in Full Tournament.",
      },
      {
        text: "9. Highest Wicket Taker: Total Wickets Taken by a Bowler in Full Tournament.",
      },
      {
        text: "10. Total 4's: Average 22 Fours will be given in case match abandoned or over reduced.",
      },
      {
        text: "11. Total 6's: Average 11 Sixes will be given in case match abandoned or over reduced.",
      },
      {
        text: "12. Total Boundaries: Average 34 Boundaries will be given in case match abandoned or over reduced.",
      },
      { text: "Super over (Super 5) will not be included." },
    ],
  },
  {
    heading: "Women's Premier League (WPL)",
    rules: [
      {
        danger: true,
        text: "1. If WPL fixture of 22 matches gets reduced due to any reason, then all the special fancies will be voided.",
      },
      {
        danger: true,
        text: "2. At any situation if result is given for any particular event, the particular result will be considered valid.",
      },
      { danger: true, text: "3. Management Decision will be Final." },
      { text: "4. Highest Innings run - Only First Innings is Valid." },
      { text: "5. Lowest Innings run - Only First Innings is Valid." },
      {
        text: "6. Highest Total Runs of WPL: Maximum Runs Scored by 2 Teams in Single Match.",
      },
      { text: "7. Highest Partnership Runs in WPL: Both Innings are Valid." },
      { text: "8. Highest Partnership Balls in WPL: Both Innings are Valid." },
      {
        text: "10. Highest Run Scorer Runs: Total Runs Scored by An Individual Batsman in Full Tournament (ORANGE CAP).",
      },
      {
        text: "11. Highest Wicket Taker Wickets: Total Wickets Taken by a Bowler in Full Tournament (PURPLE CAP).",
      },
      {
        text: "13. Total 4's: Average 34 Fours will be given in case match abandoned or over reduced.",
      },
      {
        text: "14. Total Wickets - Average will 12 Wickets be given in case match abandoned or over reduced.",
      },
      {
        text: "15. Total Wides - Average 8 Wides will be given in case match abandoned or over reduced.",
      },
      { danger: true, text: "40. Super over will not be included." },
    ],
  },
  {
    heading: "Pakistan Super League (PSL)",
    rules: [
      {
        text: "1. If PSL fixture of 34 matches gets reduced due to any reason, then all the special fancies will be voided.",
      },
      {
        text: "2. Total Matches 1st over runs: Average 6 runs will be given in case match abandoned or over reduced (only 1st innings valid).",
      },
      {
        text: "3. Total Matches 1st 6 over runs: Average 50 runs will be given in case match abandoned or over reduced (Only 1st Innings valid).",
      },
      {
        text: "4. Total fours: Average 32 fours will be given in case match abandoned or over reduced.",
      },
      {
        text: "5. Total sixes: Average 13 sixes will be given in case match abandoned or over reduced.",
      },
      {
        text: "6. Total 30's: Average 2 Thirties will be given in case match abandoned or over reduced.",
      },
      {
        text: "7. Total Fifties - Average 2 Fifties will be given in case match abandoned or over reduced.",
      },
      {
        text: "8. Total Wickets - Average 13 Wickets will be given in case match abandoned or over reduced.",
      },
      {
        text: "9. Total Wides - Average 11 Wides will be given in case match abandoned or over reduced.",
      },
      {
        text: "10. Total Extras - Average 18 Extras will be given in case match abandoned or over reduced.",
      },
      {
        text: "31. In fastest fifty always the first 50 runs will be considered. Super over will not be included.",
      },
    ],
  },
  {
    heading: "Kabaddi",
    rules: [
      {
        text: "In any circumstances management decision will be final related to all Fancy of kabaddi of our exchange.",
      },
      { text: "All fancy bets will be validated when match has been tied." },
      {
        text: "Result of individual player of fancy will be validated only when player play that match.",
      },
      {
        text: "In any case wrong rate has been given in fancy that particular bets will be deleted.",
      },
      {
        text: "For Playoffs Final Result Of 40 Minutes Of Two Halves Will Be Valid In Our Exchange.",
      },
    ],
  },
  {
    heading: "Horse Racing",
    rules: [
      { danger: true, text: "General" },
      {
        text: "1. All individual race markets will be determined according to the official result at the time of the 'weigh-in' announcement. Subsequent disqualifications, appeals or amendments to the result will be disregarded.",
      },
      {
        text: "2. If a race is abandoned or otherwise declared void, or in the event of a walkover, all bets on that race will be void.",
      },
      {
        text: "3. If the scheduled venue is changed after the market has been loaded by us, all bets will be void.",
      },
      {
        text: "4. If a scheduled surface type is changed (e.g., turf to dirt) all bets will stand.",
      },
      { danger: true, text: "Non-Runner Rule" },
      {
        text: "5. Our non-runner rule relates to the adjustment of odds-on bets already matched when a horse in a race is declared a non-runner.",
      },
      {
        text: "10. As soon as We become aware that a horse is an official non-runner, all matched bets on that horse will be void and the horse will be removed from the market.",
      },
      {
        text: "19. The traded price may be further reduced if any other horse(s) is subsequently declared a non-runner, however, odds cannot be reduced below 1.01.",
      },
      {
        text: "22. Card numbers are posted as a guide only: bets are placed on a named horse. Horses will not be coupled.",
      },
    ],
  },
  {
    heading: "World Cup",
    rules: [
      {
        danger: true,
        text: "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate.",
      },
      {
        danger: true,
        text: "In case of any circumstances, management decision will be final for all the fancies under world cup.",
      },
      {
        text: "Match 1st over run:- This fancy is valid only for first innings of the match, Average 4 runs will be given in case of match abandoned.",
      },
      {
        text: "Highest inning run:- This fancy is valid only for first innings of the match.",
      },
      {
        text: "Total Fours:- Average 48 Fours will be given if the match is abandoned or over reduced.",
      },
      {
        text: "Total Sixes:- Average 10 Sixes will be given if the match is abandoned or over reduced.",
      },
      {
        text: "Total Wickets:- Average 15 Wickets will be given if the match is abandoned or over reduced.",
      },
      {
        text: "Total Wide:- Average 14 Wide will be given if the match is abandoned or over reduced.",
      },
      {
        text: "Total Extras:- Average 25 Extras will be given if the match is abandoned or over reduced.",
      },
      {
        text: "Total Fifties:- Average 3 Fifties will be given if the match is abandoned or over reduced.",
      },
      {
        text: "Total Centuries:- Average 1 century will be given if the match is abandoned or over reduced.",
      },
      {
        text: "All fancy related to Individual teams are valid only for league matches (9 matches played by the teams in league stages).",
      },
    ],
  },
  {
    heading: "Binary",
    rules: [
      {
        danger: true,
        text: "1. All session's bets will be confirmed at market rate only.",
      },
      {
        danger: true,
        text: "2. All session's settlement price means result can be checked from exchange's official sites.",
      },
      {
        danger: true,
        text: "3. All session's result will be settlement price provided by exchange after market close.",
      },
      {
        danger: true,
        text: "4. Every product has two types of prices SPOT and FUTURE. We provide only near month's FUTURE price in Binary Session.",
      },
      {
        danger: true,
        text: "Session's timings: NSE Markets (NIFTY, BANKNIFTY, etc.) - Monday to Friday 10:00 AM to 2:30 PM & MCX Markets (GOLD, SILVER, CRUDEOIL) - Monday to Friday 11:30 AM to 10:30 PM.",
      },
      { text: "Same bets same time from multiple id not allowed." },
      {
        text: "Operating and market making bets (cheating/line/chamka bets) are not allowed.",
      },
      {
        text: "If any case wrong rate has been given in fancy that particular bets will be cancelled.",
      },
      {
        text: "Deleted bets will remove under 24hr and clients will be notified.",
      },
    ],
  },
  {
    heading: "Match",
    rules: [
      {
        text: "Company reserves the right to suspend/void any id/bets if the same is found to be illegitimate. Note: only winning bets will be voided.",
      },
      {
        text: "CRICKET Match Odds: In the event of match not being completed or tied all bets will be void.",
      },
      {
        text: "TENNIS Match Odds: If 1st set has been not completed at the time of the retirement or disqualification, then all bets relating to that individual match will be void.",
      },
      {
        text: "FOOTBALL Match Odds: All bets apply to the relevant full 'regular time' period including stoppage time. Any extra-time and/or penalty shoot-out is not included.",
      },
      {
        text: "FOOTBALL Under_Over Goals: In the event of a match starting but not being completed, all bets will be void, unless the specific market outcome is already determined.",
      },
    ],
  },
  {
    heading: "Khado",
    rules: [
      { text: "Only First inning valid for T20 and one day matches." },
      {
        text: "Same will be work like Lambi. If match abandoned or over reduced, all bets will be deleted.",
      },
      { text: "You can choose your own value in this event." },
    ],
  },
  {
    heading: "Election",
    rules: [
      {
        danger: true,
        text: "1. This Market is to decide the winner of various legislative assemblies of india.",
      },
      {
        danger: true,
        text: "2. Bets will be settled on the exact number of seats won by the nominated party in that particular election season, as determined by the Election Commission of India.",
      },
      {
        danger: true,
        text: "3. All bets will be voided if the election doesn't take place in given time by election commission or as per our exchange management decision.",
      },
      {
        danger: true,
        text: "4. Accidental issues during the election will not be counted in our exchange.",
      },
      {
        danger: true,
        text: "5. If any candidate withdraws his/her nomination or his/her nomination is cancelled for any reason, including death, all bets in the market will be settled as per the decision of our Exchange Management.",
      },
    ],
  },
  {
    heading: "Virtual Tennis",
    rules: [
      {
        text: "1. If streaming stops or some technical issue occurs, the match will be abandoned.",
      },
      {
        text: "2. If there is any technical interference in the match then also the match will be abandoned.",
      },
      {
        text: "3. There will be 3 sets in the match. There are 3 games in 1 set.",
      },
      {
        text: "4. In the match, within any set, there are 3-3 games between the two players (level game) till a tie break of 5 points is played.",
      },
    ],
  },
];

const Rules = () => {
  const [activeHeading, setActiveHeading] = React.useState(
    RULES_DATA[0]?.heading || null
  );

  return (
    <>
      <div id="accordion">
        <div className="panel-group">
          {RULES_DATA.map((section) => {
            const isOpen = activeHeading === section.heading;

            return (
            <div
              key={section.heading}
              heading={section.heading}
              className="panel panel-open"
              style={{ display: "block" }}
            >
              <div className="panel card panel-default">
                <div
                  role="tab"
                  className="panel-heading card-header panel-enabled"
                >
                  <div className="panel-title">
                    <div
                      role="button"
                      className="accordion-toggle"
                      aria-expanded={isOpen}
                      onClick={() =>
                        setActiveHeading(
                          isOpen ? null : section.heading
                        )
                      }
                    >
                      <button type="button" className="btn btn-link">
                        {section.heading}{" "}
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  role="tabpanel"
                  className={`panel-collapse collapse${
                    isOpen ? " in show" : ""
                  }`}
                  aria-hidden={isOpen ? "false" : "true"}
                  style={{ display: isOpen ? "block" : "none" }}
                >
                  <div className="panel-body card-block card-body">
                    <table className="table table-bordered">
                      <tbody>
                        {section.rules.map((rule, index) => (
                          <tr key={`${section.heading}-${index}`}>
                            <td>
                              <span
                                className={
                                  rule.danger ? "text-danger" : undefined
                                }
                              >
                                {rule.text}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          );})}
        </div>
      </div>
    </>
  );
};

export default Rules;
